<template>
    <div id="case">
        <div class="case1">
            <img :src="url+banner.images" alt="" @click="jumpbannerpage(banner.url)">
        </div>
        <div class="case2">
            <div class="title">
                <p><img src="@/assets/case/icon2.png" alt=""></p>
                <span>成功案例</span>
                <p><img src="@/assets/case/icon1.png" alt=""></p>
            </div>
            <ul class="list1">
                <li v-for="(item,index) in case1" :key="index">
                    <div class="titlebox">
                        <div>
                            <img :src="url+item.image" alt="">
                        </div>
                        <span>{{item.title}}</span>
                    </div>
                    <div class="subtitle">{{item.subtitle}}</div>
                    <div class="tip">
                        <span>{{item.fans}}</span>
                        <span>{{item.income}}</span>
                    </div>
                    <p class="button" @click="jumpcase(item.id)">查看案例</p>
                </li>
            </ul>
            <ul class="list2">
                <li v-for="(item,index) in case2" :key="index" @click="jumpcase(item.id)">
                    <img :src="url+item.image" alt="">
                    <span class="titlebox">{{item.title}}</span>
                    <div class="subtitle">{{item.subtitle}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { rotationmap,casedata } from '@/api/api'
export default {
    name:"about",
    data(){
        return {
            url : window.url,
            banner: {}, 
            case1:[],
            case2:[]
        }
    },
    mounted(){
        var that =this
        rotationmap({'type':7}).then((response) => {
            that.banner = response.data.data[0]
        })
        casedata().then((response) => {
            this.case1 = response.data.hot
            this.case2 = response.data.nothot
            //初始化动画
            that.$nextTick(()=>{
                that.$wow.init()
            })
        })
    },
    methods:{
        jumpcase(e){
            this.$router.push(
                {
                    name:"casede",
                    params:{id:e}
                }
            )
        },
        jumpbannerpage(e){
            if(e != this.$route.path) {
                this.$router.push(e)
            }
        }
    }
}
</script>

<style lang="less">
@media (min-width:750px) {
    #case{
        background: #F8F8F8;
        .case1{
            img{
                width: 100%;
                display: block;
            }
        }
        .case2{
            width: 1300px;
            margin:62px auto 0;
            .title{
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 32px;
                font-weight: normal;
                color: #000000;
                padding-bottom: 50px;
                span{
                    margin:0 20px;
                }
                p{
                    flex:0 0 40%;
                    display: flex;
                    align-items: center;
                    img{
                        width: 100%;
                    }
                }
            }
            .list1{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                li{
                    flex:0 0 30%;
                    padding: 40px;
                    background: #FFFFFF;
                    box-shadow: 0px 3px 12px 1px rgba(66,69,70,0.1);
                    border-radius: 12px 12px 12px 12px;
                    margin-bottom: 40px;
                    .subtitle{
                        width: 100%;
                        word-break: break-all;
                        font-size: 16px;
                        font-weight: normal;
                        color: #000000;
                        line-height: 1.8;
                        margin-bottom: 28px;
                    }
                    .titlebox{
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        font-size: 20px;
                        font-weight: normal;
                        color: #000000;
                    }
                    img{
                        width: 100px;
                        // height: 100px;
                        background: #F3F3F3;
                        border-radius: 10px;
                        border: none;
                        outline: none;
                        margin-right: 22px;
                        overflow: hidden;
                    }
                    .tip{
                        font-size: 24px;
                        font-weight: bold;
                        color: #FF4F4F;
                        span:nth-child(1){
                            margin-right: 14px;
                        }
                    }
                    .button{
                        width: 140px;
                        height: 40px;
                        background: #EBF1FF;
                        cursor: pointer;
                        font-size: 16px;
                        font-weight: 400;
                        color: #3270FE;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-top: 20px;
                    }
                }
            }
            .list2{
                display: flex;
                flex-wrap: wrap;
                li{
                    cursor: pointer;
                    flex:0 0 23%;
                    margin-right: 2.6%;
                    padding: 40px;
                    background: #FFFFFF;
                    box-shadow: 0px 3px 12px 1px rgba(66,69,70,0.1);
                    border-radius: 12px 12px 12px 12px;
                    margin-bottom: 40px;
                    text-align: center;
                    img{
                        width: 100px;
                        height: 100px;
                        background: #F3F3F3;
                        border-radius: 10px;
                        border: none;
                        outline: none;
                        overflow: hidden;
                    }
                    .titlebox{
                        text-align: center;
                        font-size: 24px;
                        font-weight: normal;
                        color: #000000;
                        margin:20px 0 25px;
                        display: block;
                    }
                    .subtitle{
                        width: 100%;
                        word-break: break-all;
                        font-size: 16px;
                        font-weight: normal;
                        color: #000000;
                        line-height: 1.8;
                        text-align: center;
                    }
                }
                li:nth-child(4n){
                    margin-right: 0;
                }
            }
        }
    }
}
@media screen and (max-width:750px) {
    #case{
        .case1{
            img{
                width: 100%;
                display: block;
            }
        }
        .case2{
            width: 100%;
            margin:20px auto 0;
            .title{
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                font-weight: normal;
                color: #000000;
                padding-bottom: 20px;
                span{
                    margin:0 10px;
                }
                p{
                    flex:0 0 38%;
                    display: flex;
                    align-items: center;
                    img{
                        width: 100%;
                    }
                }
            }
            .list1{
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                li{
                    flex:0 0 90%;
                    padding: 10px;
                    background: #FFFFFF;
                    box-shadow: 0px 3px 12px 1px rgba(66,69,70,0.1);
                    border-radius: 12px 12px 12px 12px;
                    margin-bottom: 40px;
                    .subtitle{
                        width: 100%;
                        word-break: break-all;
                        font-size: 16px;
                        font-weight: normal;
                        color: #000000;
                        line-height: 1.8;
                        margin-bottom: 28px;
                    }
                    .titlebox{
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        font-size: 20px;
                        font-weight: normal;
                        color: #000000;
                    }
                    img{
                        width: 60px;
                        height: 60px;
                        background: #F3F3F3;
                        border-radius: 10px;
                        border: none;
                        outline: none;
                        margin-right: 22px;
                        overflow: hidden;
                    }
                    .tip{
                        font-size: 24px;
                        font-weight: bold;
                        color: #FF4F4F;
                        span:nth-child(1){
                            margin-right: 14px;
                        }
                    }
                    .button{
                        width: 140px;
                        height: 40px;
                        background: #EBF1FF;
                        cursor: pointer;
                        font-size: 16px;
                        font-weight: 400;
                        color: #3270FE;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-top: 20px;
                    }
                }
            }
            .list2{
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                li{
                    cursor: pointer;
                    flex:0 0 90%;
                    padding: 10px;
                    background: #FFFFFF;
                    box-shadow: 0px 3px 12px 1px rgba(66,69,70,0.1);
                    border-radius: 12px 12px 12px 12px;
                    margin-bottom: 40px;
                    text-align: center;
                    img{
                        width: 100px;
                        height: 100px;
                        background: #F3F3F3;
                        border-radius: 10px;
                        border: none;
                        outline: none;
                        overflow: hidden;
                    }
                    .titlebox{
                        text-align: center;
                        font-size: 24px;
                        font-weight: normal;
                        color: #000000;
                        margin:20px 0 25px;
                        display: block;
                    }
                    .subtitle{
                        width: 100%;
                        word-break: break-all;
                        font-size: 16px;
                        font-weight: normal;
                        color: #000000;
                        line-height: 1.8;
                        text-align: center;
                    }
                }
                li:nth-child(4n){
                    margin-right: 0;
                }
            }
        }
    }
 
}
</style>